<!--
  @Description 附件上传
  @Date 2022-10-24
  @Author liufu
  1.相同日期的附件相同（弃用）
  2.根据当前问题的提出日期作为过滤的条件（弃用）
  3.2022-09-08 改为单行对应附件
-->
<template>
  <!-- <el-drawer
    title="附件上传"
    :visible.sync="attachmentDisplay"
    direction="btt"
    size="30%"
    :before-close="handleClose"
    @opened="opened"
    @closed="closed"
  > -->
  <vxe-modal ref="modal" v-model="formVisible" title="附件" width="70%" height="70%" @show="opened" @close="closed">
    <el-button
      size="mini"
      type="primary"
      @click="handleUpload"
      :disabled="!this.isMyCompany"
      style="margin-bottom: 10px"
      >上传</el-button
    >
    <vxe-grid
      ref="xTable"
      size="mini"
      :column-config="{ minWidth: '80px' }"
      border
      keep-source
      :height="tableHeight"
      resizable
      show-overflow
      highlight-hover-row
      highlight-current-row
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        enterToTab: true,
        isClip: true
      }"
      :mouse-config="{ area: true, extension: true }"
      :data="tableData"
      :empty="'false'"
      :columns="gridColumns"
    >
    </vxe-grid>

    <!-- 生成进度框 -->
    <vxe-modal v-model="showProress" title="进度" :showHeader="false" height="50" size="mini">
      <el-progress
        :text-inside="true"
        :stroke-width="26"
        :percentage="percentage"
        :format="processformat"
      ></el-progress>
    </vxe-modal>
    <!-- 选择文件夹 -->
    <input type="file" ref="uploadExcel" v-show="false" id="open" multiple="multiple" @change="uploadFile" />
    <!-- <imgModal ref="imgModal" :imgBase64Arr="imgBase64Arr"></imgModal> -->
    <!-- </el-drawer> -->
  </vxe-modal>
</template>

<script>
import { BASEURL } from '@/axios/baseUrlConfig.js'
import { MessageBox } from 'element-ui'
// import imgModal from './AttachmentDrawerImgModal'
export default {
  props: {
    // 是否打开
    attachmentDisplay: {
      type: Boolean,
      default: false
    },
    // 主键值
    keyValue: {
      type: Number,
      default: 0
    },
    // 是否可编辑
    edit: {
      type: Boolean,
      default: false
    },
    parentObj: Object
  },
  components: {
    // imgModal
  },
  data() {
    return {
      // 窗口显示状态
      formVisible: false,
      // 列头
      gridColumns: [],
      // 是否显示进度
      showProress: false,
      // 当前显示进度字符串
      processStr: '',
      // 进度百分比
      percentage: 0,
      txtOpinion: '',
      tableData: [],
      // 预览图片flag
      imgFlag: false,
      imgBase64Arr: [],
      // 当前选中行的提出日期（弃用）
      // curSelectDate: '',
      // ---- 按nginx进行上传的方式 -----
      rowId: -1,
      // attachRowIdList: [],
      // 总上传数量
      fileCount: 0,
      // 上传完成信息
      completeList: [],
      // 上传信息
      arrayUpload: []
    }
  },
  created() {},
  methods: {
    // 上传
    handleUpload() {
      this.$refs.uploadExcel.click()
    },
    // 初始化列头
    InitColumn() {
      let that = this
      that.gridColumns = [{ type: 'seq', width: '45' }]
      if (this.parentObj.form.userCompany === this.$store.state.userInfo.company) {
        that.gridColumns.push(
          // 超级权限才能删除
          {
            field: 'delete',
            title: '删除',
            visible: this.isMyCompany,
            width: '50',
            align: 'align:',
            slots: {
              default: ({ row }) => {
                return [
                  <i
                    id='vxeDelete'
                    class='el-icon-delete-solid'
                    onClick={() => {
                      this.handleDelete(row)
                    }}
                  ></i>
                ]
              }
            }
          }
        )
      }
      that.gridColumns = [
        ...that.gridColumns,
        {
          title: '下载',
          align: 'center',
          width: '50',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  class='el-icon-download'
                  onClick={() => {
                    this.handleDown(row)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          field: 'display',
          title: '文件名',
          slots: {
            default: ({ row, column }) => {
              return [
                <el-link onClick={() => this.getFileUrl(row)} type='primary'>
                  {row[column.property] + row['type']}
                </el-link>
              ]
            }
          }
        },
        // { field: 'fileURL', title: '路径', visible: false },
        // { field: 'aSize', title: '文件大小' },
        { field: 'addedBy', width: '90px', title: '上传人' },
        { field: 'addedTime', width: '120px', title: '上传日期', formatter: 'formatDate' }
      ]
    },
    // 打开附件上传弹窗
    async opened() {
      this.InitColumn()
      if (this.keyValue) {
        const { data: res } = await this.$http.get('/Common/DPBugs/file', {
          params: {
            id: this.keyValue,
            objectType: 'Processing'
          },
          headers: {
            cooperation: true
          }
        })
        if (res.isSuccess) {
          this.tableData = res.data
        } else {
          MessageBox({
            message: res.errorMessage,
            type: 'error',
            title: '提示'
          })
        }
      } else {
        this.tableData = []
      }

      this.$refs.xTable.resetColumn()
      this.tableColumns = this.$refs.xTable.getTableColumn().fullColumn
      // 是否显示删除列
      this.tableColumns.forEach(column => {
        if (['delete'].includes(column.property)) {
          column.visible = this.edit
        }
      })
      this.$refs.xTable.refreshColumn()
    },
    // 获取当前资源的静态路径并预览
    async getFileUrl(row) {
      const realFileUrl = await this.handleRealFileUrl(row)
      // res 是返回的资源路径
      this.openPreviewWindow(realFileUrl) // 存在库里面的是完整路径
    },
    openPreviewWindow(url) {
      // 全屏显示
      var width = window.screen.availWidth
      var height = window.screen.availHeight
      window.open(url, '', `width=${width},height=${height},location=no,status=no`)
    },
    async closed() {
      // this.$parent.refresh()
    },
    // 转换base64
    blobToDataURI(blob, callback) {
      let reader = new FileReader()
      reader.onload = e => {
        callback(e.target.result)
      }
      reader.readAsDataURL(blob)
    },
    // 打开文件
    handleOpenFile() {
      this.$refs.uploadExcel.click()
    },
    // 关闭前更新显示状态
    // handleClose() {
    //   this.$emit('update:attachmentDisplay', false)
    // },
    /**
     * 上传
     */
    async uploadFile(event) {
      let that = this
      // if (this.attachRowIdList.length > 0) {
      that.fileCount = event.target.files.length
      if (event.target.files.length === 0) {
        return
      }
      // 限制只能上传一个
      // that.fileCount = 1
      that.completeList = []
      that.arrayUpload = []
      that.percentage = 0
      that.processStr = `${that.percentage}%`
      for (let fileObj of event.target.files) {
        that.uploadSingle(fileObj)
      }
      // that.uploadSingle(event.target.files[0])
      // }
      event.target.value = ''
    },
    // 上传一个文件
    uploadSingle(fileObj) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const that = this
      const guID = that.guid()
      let formData = new FormData()
      formData.append('file', fileObj)
      formData.append('vuePathName', '')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN',
          'loading': false
        },
        timeout: 0
      }
      that.$http
        .post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
        .then(({ data: res }) => {
          if (res.isSuccess) {
            that.completeList.push(res.data)
            if (that.completeList.length === that.fileCount) {
              that.writeToDB()
            }
          } else {
            that.$message.error(res.errorMessage)
          }
        })
        .catch(err => {
          that.$message.error(err)
        })
      let timer = setInterval(async () => {
        let { data: res } = await that.$http.get(`${upload}/progress?X-Progress-ID=${guID}`, {
          headers: { loading: false }
        })
        res = res.replace('(', '')
        res = res.replace(')', '')
        res = res.replace(';', '')
        res = JSON.parse(res)
        if (res.state === 'uploading') {
          let pre = 100
          if (res.size > 0) {
            pre = res.received / res.size
            pre = (pre * 100).toFixed(2)
            if (res.received < res.size && pre === 100) {
              pre = 99.99
            }
          }
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = pre
          }
          that.pre()
        } else {
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = 100
          }
          that.pre()
          clearInterval(timer)
        }
      }, 1000)
      that.arrayUpload.push({ guID: guID, timer: timer, pre: 0 })
      setTimeout(() => {
        if (that.percentage < 100) {
          that.showProress = true
        }
      }, 500)
    },
    // 计算总进度
    pre() {
      let that = this
      let sumPre = this.$utils.sum(that.arrayUpload, 'pre')
      that.percentage = sumPre / that.fileCount
      that.processStr = `${that.percentage}%`
    },
    // 写入应用服务器
    async writeToDB() {
      let that = this
      const fileList = that.completeList.map(item => {
        const temp = {
          objectID: that.keyValue,
          objectType: 'Processing',
          display: item.aDisplay,
          filePath: item.aPath,
          type: item.aType,
          addedBy: this.$store.state.userInfo.userName,
          addedTime: this.ykDateFormat('yyyy-MM-dd', new Date()),
          byteSize: item.aLength
        }
        return temp
      })
      const { data: res } = await that.$http.post(`/Common/DPBugs/file`, fileList, {
        headers: {
          cooperation: true
        }
      })
      if (res.isSuccess) {
        that.$message.success('上传成功')
        // that.$parent.refresh()
        that.opened()
      } else {
        that.$message.error(res.errorMessage)
      }
      that.percentage = 100
      that.completeList = []
      that.arrayUpload = []
      that.showProress = false
    },
    // 删除
    handleDelete(row) {
      MessageBox.confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let that = this
          const { data: res } = await that.$http.delete(`/Common/DPBugs/file/${row.id}`, {
            headers: {
              cooperation: true
            }
          })
          if (res.isSuccess) {
            that.$message.success('删除成功')
            that.opened()
          } else {
            that.$message.error(res.errorMessage)
          }
        })
        .catch(() => {})
    },
    // 下载
    async handleDown(row) {
      let eleLink = document.createElement('a')
      eleLink.download = row.display + row.type
      eleLink.href = await this.handleRealFileUrl(row)
      eleLink.click()
      eleLink.remove()
    },
    // 获取真实路径
    async handleRealFileUrl(row) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const { data: res } = await this.$http.get('/Base/BAttachment/secret', {
        params: {
          link: upload + '/download/' + row.filePath
        },
        headers: {
          cooperation: true
        }
      })
      return res
    },
    // 进度格式化
    processformat() {
      return this.processStr
    },
    guid() {
      var guid = ''
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
      }
      return guid
    }
  },
  computed: {
    isMyCompany() {
      return this.parentObj.form.userCompany === this.$store.state.userInfo.company
    },
    vuePathName() {
      return this.$route.params.vueName
    },
    router() {
      let menu = JSON.parse(JSON.stringify(this.$store.state.menulist))
      let path = this.$route.path

      for (let item of menu) {
        for (let subItem of item.children) {
          for (let i of subItem.children) {
            if ('/' + i.md5Path === path) {
              return i.path
            }
          }
        }
      }
      return ''
    },
    tableHeight() {
      return this.$store.state.clientHeight * 0.7 - 110 + 'px'
    }
  }
}
</script>

<style lang="less" scoped>
.toolBox {
  margin-bottom: 5px;
  padding: 0 0 0 5px;
}
.select {
  margin-left: 10px;
  margin-right: 10px;
}
:focus {
  outline: 0;
}
/deep/ .el-drawer__header {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 5px;
  padding: 5px 10px 0;
}

/deep/ .vxe-body--row {
  height: 40px !important;
}
</style>
